import { createApi } from '@reduxjs/toolkit/query/react';
import { UUID } from '@/types';
import { TGetAvailableChartsResponse } from '@/features/chart-configuration/apiSlice';
import { baseQuery } from '@/api/baseQuery';

export const GET_QUERY_AVAILABLE_CHARTS = 'getQueryAvailableCharts';

export const queryConfigurationApi = createApi({
  reducerPath: 'queryConfigurationApi',
  baseQuery,
  endpoints: (builder) => ({
    [GET_QUERY_AVAILABLE_CHARTS]: builder.query<
      TGetAvailableChartsResponse,
      { datasourceId: UUID; queryId: Maybe<UUID> }
    >({
      query: ({ datasourceId, queryId }) =>
        `datasources/${datasourceId}/queries/${queryId}/available-charts`,
    }),
  }),
});

export const { useGetQueryAvailableChartsQuery } = queryConfigurationApi;
